/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDepartmentList(params) {
        return HttpService.get(environment.API_DEPARTMENT_LIST, {
            params,
        });
    },
    getRiskAssessmentHeader() {
        return HttpService.get(environment.API_HEADER_RISK_ASSESSMENT);
    },
    createRiskAssessmentHeader() {
        return HttpService.post(environment.API_RISK_ASSESSMENT);
    },
    getRiskListTab(riskId) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/tabs/' + riskId
        );
    },
    getStatus(params) {
        return HttpService.get(environment.API_GET_STATUS, {
            params,
        });
    },
    exportRiskAssessment(params) {
        return HttpService.get(environment.API_RISK_ASSESSMENT + '/excel', {
            params,
            responseType: 'blob',
        });
    },
    exportRiskRegisterList(params) {
        return HttpService.get(
            environment.API_RISK_REGISTER + '/export/excel',
            {
                params,
                responseType: 'blob',
            }
        );
    },
    publicRiskAssessment(params) {
        return HttpService.patch(
            environment.API_RISK_ASSESSMENT + '/publish',
            params
        );
    },
    searchRiskAssessmentRopa(params) {
        return HttpService.get(environment.API_SEARCH_RISK_ASSESSMENT, {
            params,
        });
    },
    searchRiskAssessmentRegister(params) {
        return HttpService.get(
            environment.API_SEARCH_RISK_ASSESSMENT_REGISTER,
            {
                params,
            }
        );
    },
    // Tab1
    getRiskFactorMaster() {
        return HttpService.get(environment.API_WFSECURE + '/m/risk-factor');
    },

    createRiskFactor(payload) {
        return HttpService.post(
            environment.API_RISK_ASSESSMENT + '/risk-factor',
            payload
        );
    },
    updateRiskFactor(payload) {
        return HttpService.put(
            environment.API_RISK_ASSESSMENT + '/risk-factor',
            payload
        );
    },

    // Tab2 + Tab3
    getDefinitions() {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/m/definitions'
        );
    },

    // Tab2
    getRiskMap() {
        return HttpService.get(environment.API_RISK_ASSESSMENT + '/m/risk-map');
    },
    createRiskMap(payload) {
        return HttpService.post(
            environment.API_RISK_ASSESSMENT + '/risk-map',
            payload
        );
    },
    updateRiskMap(payload) {
        return HttpService.put(
            environment.API_RISK_ASSESSMENT + '/risk-map',
            payload
        );
    },

    // Tab3
    getLikelihood() {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/m/likelihood'
        );
    },
    createLikelihood(payload) {
        return HttpService.post(
            environment.API_RISK_ASSESSMENT + '/likelihood',
            payload
        );
    },
    updateLikelihood(payload) {
        return HttpService.put(
            environment.API_RISK_ASSESSMENT + '/likelihood',
            payload
        );
    },

    getHistories(params) {
        return HttpService.get(environment.API_RISK_ASSESSMENT + '/history', {
            params,
        });
    },

    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/history/detail',
            {
                params,
            }
        );
    },

    getRiskAssessmentDetail() {
        return HttpService.get(environment.API_RISK_ASSESSMENT);
    },
    getPublishRiskAssessmentDetail() {
        return HttpService.get(environment.API_PUBLISH_RISK_ASSESSMENT);
    },
    //Dashboard
    getActivityRisk() {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/activity/risk'
        );
    },
    getActivityRiskRegister() {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/activity/risk-register'
        );
    },
    getDepartmentActivityRisk(params) {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/department/activity/risk',
            {
                params,
            }
        );
    },
    getDepartmentRiskRegister(params) {
        return HttpService.get(
            environment.API_RISK_ASSESSMENT + '/department/risk-register',
            {
                params,
            }
        );
    },
};
